// API helper for authenticated requests
import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE =
  import.meta.env.VITE_API_BASE_URL ||
  (typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:3000"
    : "");

if (!API_BASE) {
  throw new Error("VITE_API_BASE_URL is missing");
}

/**
 * Get authorization headers with Firebase ID token
 * @returns {Promise<{Authorization: string}>} Headers object with Bearer token
 */
export const getAuthHeaders = async () => {
    const auth = getAuth();
    if (!auth.currentUser) {
        throw new Error("User not authenticated");
    }
    const token = await auth.currentUser.getIdToken();
    return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
    };
};

/**
 * Authenticated GET request
 */
export const authGet = async (endpoint) => {
    const headers = await getAuthHeaders();
    return axios.get(`${API_BASE}${endpoint}`, { headers });
};

/**
 * Authenticated POST request
 */
export const authPost = async (endpoint, data) => {
    const headers = await getAuthHeaders();
    return axios.post(`${API_BASE}${endpoint}`, data, { headers });
};

/**
 * Authenticated DELETE request
 */
export const authDelete = async (endpoint) => {
    const headers = await getAuthHeaders();
    return axios.delete(`${API_BASE}${endpoint}`, { headers });
};

/**
 * Authenticated PUT request
 */
export const authPut = async (endpoint, data) => {
    const headers = await getAuthHeaders();
    return axios.put(`${API_BASE}${endpoint}`, data, { headers });
};
